import { Component, Input } from '@angular/core';
import { TcmBaseForm } from '../../../../modules/tcm-common/base/tcm-base-form';
import { SecureBaseComponentContext } from '../../../../modules/tcm-common/services/secure-base-component-context.service';
import { EmailTemplateDataService } from '../../../../services/email-template-data.service';
import { ListOption, Deferred } from '../../../../modules/tcm-core.module';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'send-email',
    templateUrl: './send-email.component.html',
    styleUrls: ['./send-email.component.scss'],
    standalone: false
})
export class SendEmailComponent extends TcmBaseForm {

  @Input()
  email: string;

  @Input()
  patientId: number;

  @Input()
  clinicId: number;

  @Input()
  emailTemplates: ListOption<number>[];

  templateId: number;
  subject: string;
  body: SafeHtml;

  private componentCancellationTokenDeferred = new Deferred();

  constructor(protected componentContext: SecureBaseComponentContext,
    private emailTemplateDataService: EmailTemplateDataService,
    private _sanitizer: DomSanitizer) {
    super();
  }

  async onEmailTemplateChanged(selectedOption: any) {
    var response = await this.emailTemplateDataService.getEmailTemplateRenderAsync(selectedOption.value, this.patientId, this.componentCancellationTokenDeferred.promise());

    this.subject = response.subject;
    this.body = this._sanitizer.bypassSecurityTrustHtml(response.body);
  }

  async sendEmail() {
    await this.wrapRemoteCallAsync(() =>
      this.emailTemplateDataService.sendEmailTemplateAsync(this.email, this.templateId, this.patientId, this.clinicId, this.componentCancellationTokenDeferred.promise())
    );

    
this.back();
  }

  ngOnDestroy(): void {
    this.componentCancellationTokenDeferred.resolve();
  }

  back() {
    this.componentContext.navService.navigateBack();
  }
}